import React, {PropTypes} from 'react';
const s = require('./noResultHeader.scss');
import {Link} from 'react-router';

const NoResultHeader = ({search, locale}) => {
  return (
    <div>
      <h1 className={s.pageTitle} data-hook="page-title">{locale.No_Results_title}</h1>
      <p className={s.pageDescription} data-hook="page-description"><Link to="/" onclick={search()}>{locale.No_Results_description}</Link></p>
    </div>
  );
};

NoResultHeader.propTypes = {
  search: PropTypes.func.isRequired,
  locale: PropTypes.object.isRequired
};

export default NoResultHeader;



// WEBPACK FOOTER //
// ./components/partial/NoResultHeader/NoResultHeader.js